import { useContext, useEffect } from 'react';

import MultiTargetSelector from '@/components/common/selection/MultiTargetSelector';
import { MinimalTarget } from '@/generated/model';
import TargetAttributesEditor from './TargetAttributesEditor';
import { useTranslation } from 'react-i18next';
import { TFunction } from 'i18next';
import { Box, Typography } from '@mui/material';

import './TargetAttributes.css';
import { ctxTargetAttributes } from '@/contexts/TargetAttributesContext';
import { getMaxTargetNumber } from '@/generated/client/reports/reports';

export default function TargetAttributesPanel() {
  const { t } = useTranslation();
  const ctx = useContext(ctxTargetAttributes);
  const selectedTargets = ctx?.selectedTargets; // TODO jo ez igy ????
  const count = selectedTargets?.length ?? 0;

  useEffect(() => {
    async function loadMaxTargetNumber() {
      const localMax = await getMaxTargetNumber();
      ctx?.setMaxTargetNumber(localMax.data);
    }
    void loadMaxTargetNumber();
  }, []);

  if (!ctx) return;

  function GetTargetLabel(
    count: number,
    selectedTargets: MinimalTarget[] | undefined,
    t: TFunction<'translation', undefined>
  ) {
    if (count === 0 || !selectedTargets) return '';
    if (count === 1) return selectedTargets[0].name;
    return t('targetAttributes.vehiclesSelected', { targetCount: count });
  }
  return (
    <div className="targetattributes-container">
      <div className="targetattributes-target-selector">
        <MultiTargetSelector
          selectedTargets={ctx.selectedTargets}
          setSelectedTargets={ctx.setSelectedTargets}
          searchText={ctx.searchText}
          setSearchText={ctx.setSearchText}
          maxElementNumber={ctx.maxTargetNumber}
        />
      </div>
      {count > 0 ? (
        <>
          <div className="targetattributes-editor-container">
            <div>
              <h3 className="targetattributes-editor-title">
                {t('targetAttributes.title')}{' '}
                {
                  <span className={count > 1 ? 'targetlabel-multiple' : 'targetlabel-single'}>
                    ({GetTargetLabel(count, selectedTargets, t)})
                  </span>
                }
              </h3>
            </div>
            <TargetAttributesEditor selectedTargets={selectedTargets} />
          </div>
        </>
      ) : (
        <>
          <Box className="empty-state-container">
            <Box
              className="empty-state-image"
              component="img"
              src="svg/EmptyState_data1_crop.svg"
              alt="not_found"
              data-qa-element-id="no_result_image"
            />
            <Typography className="empty-state-main-text" data-qa-element-id="no_result_main_text">
              {t('targetAttributes.emptyStateMainText')}
            </Typography>
            <Typography className="empty-state-sub-text" gutterBottom data-qa-element-id="no_result_sub_text">
              {t('targetAttributes.emptyStateSubText')}
            </Typography>
          </Box>
        </>
      )}
    </div>
  );
}
